import { useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';
import { Download, Trash2 } from 'lucide-react';
import { toast } from 'sonner';

export default function AdminNewsletter() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    const { data } = await supabase.from('newsletter').select('*').order('created_at', { ascending: false });
    setItems(data || []); setLoading(false);
  };
  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    if (!window.confirm('Delete subscriber?')) return;
    const { error } = await supabase.from('newsletter').delete().eq('id', id);
    if (error) toast.error(error.message); else { toast.success('Deleted'); load(); }
  };
  const exportCsv = () => {
    const rows = [['Email','Created'], ...items.map(i => [i.email, i.created_at])];
    const csv = rows.map(r => r.map(c => `"${(c||'').toString().replace(/"/g,'""')}"`).join(',')).join('\n');
    const a = document.createElement('a'); a.href = URL.createObjectURL(new Blob([csv], { type: 'text/csv' })); a.download = `newsletter-${Date.now()}.csv`; a.click();
  };

  return (
    <div>
      <div className="flex items-center justify-between flex-wrap gap-4">
        <div>
          <h1 className="font-display text-3xl text-ink-900">Newsletter subscribers</h1>
          <p className="mt-1 text-sm text-ink-500">{items.length} total</p>
        </div>
        <button onClick={exportCsv} className="inline-flex items-center gap-2 rounded-full border border-ink-100 bg-white px-5 py-2.5 text-sm"><Download className="h-4 w-4" /> Export CSV</button>
      </div>
      <div className="mt-6 overflow-hidden rounded-2xl border border-ink-100 bg-white">
        {loading ? <div className="p-8 text-center text-ink-500">Loading…</div> : items.length === 0 ? <div className="p-8 text-center text-ink-500">No subscribers yet.</div> : items.map(i => (
          <div key={i.id} className="flex items-center justify-between border-b border-ink-100 px-5 py-3 text-sm">
            <span className="text-ink-900">{i.email}</span>
            <div className="flex items-center gap-3">
              <span className="text-xs text-ink-400">{new Date(i.created_at).toLocaleDateString()}</span>
              <button onClick={() => remove(i.id)} className="inline-flex h-8 w-8 items-center justify-center rounded-lg border border-ink-100 text-ink-500 hover:border-red-500 hover:text-red-500"><Trash2 className="h-3.5 w-3.5" /></button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
